import React, { useContext, useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Popup from 'reactjs-popup';
import { XLg } from 'react-bootstrap-icons';
import styles from './CSPCancelESTSubscription.module.scss';
import Table from 'react-bootstrap/Table';
import { api } from '../../../../../../../../Utils/API';
import loadingGif from "../../../../../../../../Assets/Images/Animations/loading-management-console.gif"
import { TEXT_SECONDARY } from '../../../../../../../../Utils/ColorsConfiguration';
import { CSPSuccessToast, CreationErrorToast } from '../../../../../../../../Utils/StaticMessages/ToastMessages';
import { MANAGE_AUTO_RENEW_STATUS_NCE } from '../../../../../../../../Utils/GlobalConstants';

const CSPCancelESTSubscription = ({subscriptionTableAPIData, subscriptionId, planName, setSubscriptionTableAPIData, cancelESTSkuPopupModalOpen, setCancelESTSkuPopupModalOpen,
  setToastSuccess, setToastError, setToastMessage, setActionCompletedRefreshSubscriptionTable, isNcePlan, setIsNcePlan, Logout, columnsSubscriptionTable, tableSubscriptionTable,
  setIsActionInProgress, setIsAutoRefreshEnabled, rowData, isFilterOrSearchActive
}) => {

  const [confirmLoadingFlag, setConfirmLoadingFlag] = useState(false);                                                                         // loading state to be dispalyed while calling api
  let ColumnNameForESTTable = ["Plan Name","SKU ID", "Commitment Term (Billing Frequency)", "Quantity", "Renewal Status"];                     // Columns of table for EST details
  const estCancellationOptions = [{"name": "Cancel Immediately", "id" : "cancel_immediately"}, {"name": "Cancel at end of term", "id" : "cancel_at_end_of_term"}];        // EST Cancellation Options
  const [optedEstCancelOption, setOptedEstCancelOption] = useState("cancel_immediately");                                                      // opted est cancellation option from available cancel options
  const [enableSubmitButton, setEnableSubmitButton] = useState(true);                                                                       // enable submit button flag
  const [enableSaveButton, setEnableSaveButton] = useState(subscriptionTableAPIData?.renewalStatus === "CANCEL_AT_END_OF_THE_TERM" ? false : true);       // enable save button flag
  const [enableCancelButon, setEnableCancelButon] = useState(true);                                                                          // enable cancel button flag
  const [confirmCancelFlag, setConfirmCancelFlag] = useState(false);
  const [cancelSubscriptionIdSelected, setCancelSubscriptionIdSelected] = useState(null);

  // Header Authorization for General API's
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };

  // handle selected est cancel option from available cancel options
  const handleCancelOptionChange = (id) => {
    setOptedEstCancelOption(id);
    setEnableSaveButton(subscriptionTableAPIData?.renewalStatus === "CANCEL_AT_END_OF_THE_TERM" ? false : true);
    setEnableSubmitButton(true);
  }

   // function makes N/w call to Cancel EST Immediately
   async function cancelEstImmediately(subscriptionId) {
      setEnableSaveButton(false);
      setEnableSubmitButton(false);
      setEnableCancelButon(false);
      let requestBody = { 
        "subscriptionId": subscriptionId,
        "renewalStatus": "CANCEL_IMMEDIATELY"             // setting cancel Immediate flag
      }
     
      await api.post(MANAGE_AUTO_RENEW_STATUS_NCE, requestBody, config)
        .then(resp => {
                       if (resp.status >= 200 && resp.status < 300) {
                          setCancelESTSkuPopupModalOpen(false);
                          setSubscriptionTableAPIData(null);
                          setToastMessage(CSPSuccessToast);
                          setToastSuccess(true);
                          setTimeout(() => {
                            setToastSuccess(false);
                          }, 5000);
                          setActionCompletedRefreshSubscriptionTable(true);
                          if (!isFilterOrSearchActive) {
                            setIsAutoRefreshEnabled(true);
                            setIsActionInProgress(false);
                          }
                        }
                    })
                    .catch(error => {
                       setIsAutoRefreshEnabled(false);
                       if (error?.status == 401 || error?.response.status == 401) {
                           Logout();
                       }
                       setEnableSubmitButton(true);
                       setEnableCancelButon(true);
                       setEnableSaveButton(subscriptionTableAPIData?.renewalStatus === "CANCEL_AT_END_OF_THE_TERM" ? false : true);
                       setToastMessage(CreationErrorToast);
                       setToastError(true);
                       setTimeout(() => {
                           setToastError(false);
                       }, 5000);
                    })
   };

   // function makes N/w call to cancel EST at end of est term
   async function cancelEstAtEndOfTerm(subscriptionId) {
      setEnableSaveButton(false);
      setEnableSubmitButton(false);
      setEnableCancelButon(false);
      let requestBody = { 
        "subscriptionId": subscriptionId,
        "renewalStatus": "CANCEL_AT_END_OF_THE_TERM"             // setting cancel_at_end_of_term flag
      }
     
      await api.post(MANAGE_AUTO_RENEW_STATUS_NCE, requestBody, config)
        .then(resp => {
                       if (resp.status >= 200 && resp.status < 300) {
                          setCancelESTSkuPopupModalOpen(false);
                          setSubscriptionTableAPIData(null);
                          setToastMessage(CSPSuccessToast);
                          setToastSuccess(true);
                          setTimeout(() => {
                            setToastSuccess(false);
                          }, 5000);
                          setActionCompletedRefreshSubscriptionTable(true);
                          if (!isFilterOrSearchActive) {
                            setIsAutoRefreshEnabled(true);
                            setIsActionInProgress(false);
                          }
                        }
                    })
                    .catch(error => {
                       setIsAutoRefreshEnabled(false);
                       if (error?.status == 401 || error?.response.status == 401) {
                           Logout();
                       }
                       setEnableSubmitButton(true);
                       setEnableCancelButon(true);
                       setEnableSaveButton(subscriptionTableAPIData?.renewalStatus === "CANCEL_AT_END_OF_THE_TERM" ? false : true);
                       setToastMessage(CreationErrorToast);
                       setToastError(true);
                       setTimeout(() => {
                           setToastError(false);
                       }, 5000);
                    })
  };

  // useEffect to handle enableSaveButton
  useEffect(() => {
    if (subscriptionTableAPIData) {
      setEnableSaveButton(subscriptionTableAPIData.renewalStatus === "CANCEL_AT_END_OF_THE_TERM" ? false : true);
    }
  }, [subscriptionTableAPIData]);

 
  return (
       <div>
            {/* For Cancel Immediately - confirmation Popup */}
            <Popup
                className="custom-modal custom-modal-md"
                open={confirmCancelFlag}
                onClose={() => { setConfirmCancelFlag(false);setCancelSubscriptionIdSelected(null); }}
                modal
                nested
            >
                {(close) => (
                    <div className="modal">
                        <div className="header p-4 py-3">
                            <h2 className="mb-0 px-3">Cancel</h2>
                            <XLg
                                size={18}
                                className="cpointer text-strong close-icon-popup-sm"
                                onClick={close}
                                color={TEXT_SECONDARY}
                            />
                        </div>
                        <Container className={`p-5 `}>
                            <p className={`pt-0 px-3 pb-5 mb-0`}>
                                <strong>Are you sure you want to Cancel Subscription?</strong>
                            </p>
                            <div className="actions">
                                <div className="d-flex justify-content-center pb-3 pt-2">
                                    <Button
                                        className="btn btn-lg mx-3 btn-border-light"
                                        variant="light"
                                        onClick={() => {
                                            close();
                                        }}
                                    >
                                        No
                                    </Button>
                                    <Button
                                        className="btn btn-md"
                                        onClick={() => {
                                           cancelEstImmediately(cancelSubscriptionIdSelected);
                                            close();
                                        }}
                                    >
                                        Yes
                                    </Button>
                                </div>
                            </div>
                        </Container>
                    </div>
                )}
            </Popup>
            {/* Cancel EST Subscription Popup */}
            <Popup
              className={"custom-modal custom-modal-xl"}
              open={cancelESTSkuPopupModalOpen}
              onClose={() => {
                setCancelESTSkuPopupModalOpen(false); setSubscriptionTableAPIData(null);
              }}
              closeOnDocumentClick={!confirmLoadingFlag}
              modal
              nested
            >
              {(close) => (
                <div className="modal">
                  <>
                    <div className="header">
                      <h2>Cancel EST Subscription</h2>
                      <XLg
                        size={18}
                        className="cpointer text-strong"
                        onClick={() => {
                            if (!confirmLoadingFlag) {
                              close();
                              setIsActionInProgress(true);
                              setIsAutoRefreshEnabled(false);
                            }
                        }}
                        color={TEXT_SECONDARY}
                       />
                    </div>
                    <Container fluid>
                      <div className='mt-5 mb-4'>
                        {!subscriptionTableAPIData &&
                           <div className={styles["loading-plans"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading. . .</p></div>
                        }
                        {subscriptionTableAPIData &&
                            <div>
                                {/* EST SKU Table */}
                                <Col md={4}>
                                  <label className='text-strong text-regular'>EST SKU</label>
                                </Col>
                                <div className='mt-4'>
                                  <Table className={`${styles['csp-change-status-core-table']}`} responsive="md">
                                    <thead className="sticky-top">
                                      <tr>
                                        {ColumnNameForESTTable.map(th => {
                                          return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity") ? "text-right" : (th === "Plan Name") ? styles["min-width"] : ""}>{th}</th>)
                                        })}
                                      </tr>
                                    </thead>
                                    <tbody>
                                       {
                                        <tr>
                                            <td>{subscriptionTableAPIData.planName}</td>
                                            <td>{subscriptionTableAPIData.planCode}</td>
                                            <td>{subscriptionTableAPIData.billingTerm}</td>
                                            <td className='text-right'>{subscriptionTableAPIData.quantity}</td>
                                            <td>{subscriptionTableAPIData.renewalDate}</td>
                                        </tr>
                                       }
                                    </tbody>
                                  </Table>
                                </div>
                            </div>
                        }
                        {/* Available EST Cancellation options */}
                        {subscriptionTableAPIData &&
                          <>
                            <p className='text-strong mt-9'>Manage the EST subscription cancellation using one of the below two options :</p>
                            <div className="radio-options-column d-flex flex-column gap-2 mt-5">
                            {estCancellationOptions.map((option, index) => (
                                <label className='mr-5' key={option.id}>
                                <input
                                    className='mr-2'
                                    type="radio"
                                    name="CancelOption"
                                    value={option.id}
                                    style={{ verticalAlign: 'top' }}
                                    checked={optedEstCancelOption === option.id}
                                    onChange={() => handleCancelOptionChange(option.id)}
                                />
                                {option.name}
                            </label>))}
                            </div>
                          </>
                        }
                        {/* Cancel & save/submit buttons */}
                        {subscriptionTableAPIData &&
                          <Row className='px-3 pb-0 mt-7'>
                              <Col md={12}>
                                <div className={`${styles['convert-btn']} btn-wrapper text-right`}>
                                {optedEstCancelOption === "cancel_immediately" ? <>
                                {/* <Button
                                    className="ml-3 mr-3 btn-border-light w-md-auto col-xs-12"
                                    variant="light"
                                    disabled={!enableCancelButon}
                                    onClick={() => {
                                      setCancelESTSkuPopupModalOpen(false); setSubscriptionTableAPIData(null); setIsActionInProgress(true); setIsAutoRefreshEnabled(false);
                                    }}
                                    sx={{ mr: 1 }} > Cancel </Button> */}
                                  {enableSubmitButton ? (
                                    <Button
                                      className="px-4 mx-2"
                                      onClick={() => {
                                         setCancelSubscriptionIdSelected(subscriptionTableAPIData.subscriptionId);
                                         setConfirmCancelFlag(true);          // trigger cancel_immediately popup confirmation
                                      }}>Cancel Subscription</Button>)
                                   : (
                                    <Button
                                      className="px-4 mx-2 btn-border-light w-md-auto col-xs-12"
                                      variant="light"
                                      disabled
                                    >Cancel Subscription</Button>
                                  )}
                                </>
                                : 
                                  <>
                                    <Button
                                        className="ml-3 mr-3 btn-border-light w-md-auto col-xs-12"
                                        variant="light"
                                        disabled={!enableCancelButon}
                                        onClick={() => {
                                          setCancelESTSkuPopupModalOpen(false); setSubscriptionTableAPIData(null); setIsActionInProgress(true); setIsAutoRefreshEnabled(false);
                                        }}
                                        sx={{ mr: 1 }}> Cancel </Button>
                                    {enableSaveButton ? (
                                       <Button
                                          className="px-4 mx-2"
                                          onClick={() => {
                                            cancelEstAtEndOfTerm(subscriptionTableAPIData.subscriptionId);          // trigger cancel_at_end_of_term n/w call
                                          }}
                                        > Save</Button>)
                                      : (
                                      <Button
                                        className="px-4 mx-2 btn-border-light w-md-auto col-xs-12"
                                        variant="light"
                                        disabled
                                      > Save</Button>
                                    )}
                                  </>
                                }
                                </div>
                              </Col>
                          </Row>
                        }
                      </div>
                    </Container>
                  </>
                </div>
              )}
            </Popup>
        </div>
    )
}

export default CSPCancelESTSubscription